// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__mjAIo"};